import React from "react";
import { Helmet } from "react-helmet";
import { useI18next, useTranslation } from "gatsby-plugin-react-i18next";

const PipeDriveChat = () => {
  const { t } = useTranslation();
  const { language } = useI18next();
  
  let configChatScript = "";
  if(language === "es"){
    configChatScript = "window.pipedriveLeadboosterConfig = {base: 'leadbooster-chat.pipedrive.com',companyId: 7411403,playbookUuid: 'aa14fb85-5636-4d61-b888-0a30680a8223',version: 2};(function () {var w = window; if (w.LeadBooster) { console.warn('LeadBooster already exists'); } else {w.LeadBooster = {q: [],on: function (n, h) {this.q.push({ t: 'o', n: n, h: h });},trigger: function (n) {this.q.push({ t: 't', n: n });},};}})();";
  }
  else if (language === "en") {
    configChatScript = "window.pipedriveLeadboosterConfig = {base: 'leadbooster-chat.pipedrive.com',companyId: 7411403,playbookUuid: '07f65e6b-8ff1-4d07-9936-999270c3ba36',version: 2};(function () {var w = window; if (w.LeadBooster) { console.warn('LeadBooster already exists'); } else {w.LeadBooster = {q: [],on: function (n, h) {this.q.push({ t: 'o', n: n, h: h });},trigger: function (n) {this.q.push({ t: 't', n: n });},};}})();";
  }
  else {
    configChatScript = "window.pipedriveLeadboosterConfig = {base: 'leadbooster-chat.pipedrive.com',companyId: 7411403,playbookUuid: '6a3c384d-b125-4bc3-b0ab-8b95389194e5',version: 2};(function () {var w = window; if (w.LeadBooster) { console.warn('LeadBooster already exists'); } else {w.LeadBooster = {q: [],on: function (n, h) {this.q.push({ t: 'o', n: n, h: h });},trigger: function (n) {this.q.push({ t: 't', n: n });},};}})();";
  }

  //const configChatScript =
  //  "window.pipedriveLeadboosterConfig = {base: 'leadbooster-chat.pipedrive.com',companyId: 7411403,playbookUuid: 'aa14fb85-5636-4d61-b888-0a30680a8223',version: 2};(function () {var w = window;if (w.LeadBooster) {console.warn('LeadBooster already exists');} else {w.LeadBooster = {q: [],on: function (n, h) {this.q.push({ t: 'o', n: n, h: h });},trigger: function (n) {this.q.push({ t: 't', n: n });},};}})();";
  const pipedriveScript =
    "https://leadbooster-chat.pipedrive.com/assets/loader.js";

  return (
    <div>
      <Helmet>
        <script type="text/javascript">{configChatScript}</script>
        <script src={pipedriveScript} async></script>
      </Helmet>
    </div>
  );
};

export default PipeDriveChat;
